module.exports = __webpack_public_path__ + "static/img/logo-blue.98f7ec1d.png";